var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCancel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9848 0.000732422C25.781 0.000732422 32.9089 7.12869 32.9089 16.0766C32.9089 24.8728 25.781 32.0007 16.9848 32.0007C8.0369 32.0007 0.908936 24.8728 0.908936 16.0766C0.908936 7.12869 8.0369 0.000732422 16.9848 0.000732422ZM7.12695 23.6595L24.5677 6.21874C22.4445 4.5505 19.8663 3.64054 16.9848 3.64054C10.0085 3.64054 4.54875 9.10026 4.54875 16.0766C4.54875 18.9581 5.4587 21.5363 7.12695 23.6595ZM26.8426 8.34196L9.25017 25.9344C11.3734 27.451 14.1032 28.5126 16.9848 28.5126C23.8094 28.5126 29.4208 22.9012 29.4208 16.0766C29.4208 13.195 28.3592 10.4652 26.8426 8.34196Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.edcfa522d0052c53450b866ee488aa1c.svg";
export { ForwardRef as ReactComponent };